export default __webpack_public_path__ + "static/media/jps.072d505e.png";